/* Swiper Global Setup - Ensure Swiper is available globally for v11 */
(function() {
    // Swiper v11 bundle includes all modules by default
    // We just need to ensure Swiper is available globally
    if (typeof Swiper !== "undefined") {
        console.debug("Swiper v11 bundle loaded successfully");
        console.debug("Swiper version:", Swiper.version || "unknown");
        
        // Make Swiper available globally (it should already be)
        window.Swiper = Swiper;
        
        // Log available properties for debugging
        console.debug("Swiper object keys:", Object.keys(Swiper));
        
        console.debug("Swiper is ready for use in components");
    } else {
        console.error("Swiper not found - check if swiper-bundle.min.js loaded correctly");
    }
})();
